import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import HomeContent from '../../components/Pages/Home';

const { displayName } = config;

export default function Home() {
  document.title = `${displayName}: Home page`;

  return (
    <Layout>
      <HomeContent />
    </Layout>
  );
}
